import React from 'react';
import {useTranslation} from 'react-i18next';
import {formatNumber} from '../../assets/utils/utils';
type Props = {
	sumMoney?: string | number;
	currency?: string;
	sumBonuses?: string | number;
	points?: string | number;
	count?: string | number;
};
const ShoppingTotal: React.FC<Props> = ({
	sumMoney,
	currency,
	sumBonuses,
	points,
	count,
}) => {
	const {t} = useTranslation();
	return (
		<div className="shopping-total">
			{count && (
				<div className="shopping-total__item">
					<div className="shopping-total__label">{t('кількість')}:</div>
					<div className="shopping-total__total">
						{formatNumber(count ?? '') || 0}
					</div>
				</div>
			)}
			{(sumBonuses || points) && (
				<div className="shopping-total__item">
					<div className="shopping-total__label">{t('всього балів')}:</div>
					<div className="shopping-total__total">
						{formatNumber(sumBonuses ?? '') || formatNumber(points ?? '')} Б
					</div>
				</div>
			)}
			{sumMoney && (
				<div className="shopping-total__item">
					<div className="shopping-total__label">
						{t('всього грошей')} {currency ? `в ${currency}` : ''}:
					</div>
					<div className="shopping-total__total">
						{formatNumber(sumMoney ?? '')} <span>{currency}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default ShoppingTotal;
